import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "vertical-nav text-center",
  id: "sidebar"
}
const _hoisted_2 = { class: "vertical-nav-inner h-100 d-flex flex-column align-items-stretch" }
const _hoisted_3 = { class: "d-flex h-100 flex-column align-items-stretch justify-content-between" }
const _hoisted_4 = { class: "flex-column align-items-start main-menu" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-home" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "menu-label" }, "Overview", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-comments" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "menu-label" }, "Sequences", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-comment" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "menu-label" }, "Messages", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fal fa-puzzle-piece",
    style: {"margin-right":"-5px"}
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "menu-label" }, "Templates", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-telescope" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "menu-label" }, "Loupes", -1)
const _hoisted_15 = { class: "flex-column align-items-start" }
const _hoisted_16 = { class: "menu-icon" }
const _hoisted_17 = { class: "fa-layers fa-fw" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-bell" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "fa-layers-counter",
  style: {"font-size":"2.25rem"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "menu-label" }, "Notifications", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-cog" })
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "menu-label" }, "Settings", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-question-circle" })
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "menu-label" }, "Support", -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 0,
  class: "menu-item d-flex flex-row align-items-center mb-4"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user-circle" })
], -1)
const _hoisted_28 = { class: "menu-label" }
const _hoisted_29 = { class: "menu-label" }
const _hoisted_30 = { class: "menu-label-detail d-flex" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "|", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Settings")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'overview'},
            exact: "",
            class: "menu-item d-flex flex-row align-items-center"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: { name: 'sequences'},
            class: "menu-item d-flex flex-row align-items-center"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: { name: 'messages'},
            class: "menu-item d-flex flex-row align-items-center"
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: { name: 'templates'},
            class: "menu-item d-flex flex-row align-items-center"
          }, {
            default: _withCtx(() => [
              _hoisted_11,
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: { name: 'snapshots'},
            class: "menu-item d-flex flex-row align-items-center"
          }, {
            default: _withCtx(() => [
              _hoisted_13,
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_router_link, {
            to: { name: 'notifications'},
            exact: "",
            class: "menu-item d-flex flex-row align-items-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _hoisted_18,
                  (_ctx.numUnreadNotifications > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.numUnreadNotifications), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_20
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: { name: 'account'},
            class: "menu-item d-flex flex-row align-items-center"
          }, {
            default: _withCtx(() => [
              _hoisted_21,
              _hoisted_22
            ]),
            _: 1
          }),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$chat.open())),
            class: "menu-item d-flex flex-row align-items-center"
          }, _hoisted_25),
          (_ctx.$auth.authenticated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$auth?.user?.email), 1),
                  _createElementVNode("div", _hoisted_30, [
                    (_ctx.$auth.authenticated)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                          class: "loupey-link"
                        }, "Logout"))
                      : _createCommentVNode("", true),
                    _hoisted_31,
                    (_ctx.$auth.authenticated)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: { name: 'user'},
                          class: "loupey-link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_32
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}